import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';

const StyledTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#ffffff',
      color: '#757575',
      borderRadius: 4.181,
      border: '1px solid #c2c2c2',

      '& fieldset': {
        border: 0,
      },
      '&:hover fieldset': {
        border: 0,
      },
      '&.Mui-focused fieldset': {
        border: 0,
      },
    },
    '& .MuiFormHelperText-contained': {
      marginLeft: 0,
      marginRight: 0,
    },
  },
})(TextField);

export default StyledTextField;
